import '../../style/base.css';
import '../../loading/index.css';
import '../../picker/index.css';